import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getReadoutName } from '../../utils/nameFormat';
export const sortReadoutFieldsStmtInstruction = `
#### Sort fields in readout
- Syntax: \`sort readout fields in <readout_name>: <field_name>, <field_name>, ... ;\`
- Example: \`sort readout fields in ${getReadoutName('Product')}: name, description, category;\`
`;
export const stmtSortReadoutFields = ({ readoutName, fieldNames }) => {
    return `sort readout fields in ${readoutName}: ${fieldNames.join(', ')};`;
};
export const sortReadoutFieldsHandler = createStructureStatementHandler({
    type: 'sort readout fields',
    parse: line => {
        const match = /^sort (readout|detail) fields in (?<readoutName>\w+): (?<fieldNames>[\w\s.,]+)/.exec(line);
        return match?.groups
            ? {
                type: 'sort detail fields',
                readoutName: match.groups.readoutName,
                fieldNames: match.groups.fieldNames.split(',').map(it => it.trim()),
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.sortReadoutFields({
                readoutName: stmt.readoutName,
                fieldNames: stmt.fieldNames,
            });
        });
    },
});
//# sourceMappingURL=SortDetailFieldsStmt.js.map